<template>
  <!-- <section>
    <v-tabs v-model="active" color="black" dark slider-color="white">
      <v-spacer></v-spacer>
      <v-tab ripple>
        Stats
      </v-tab>
      <v-tab ripple>
        Add Question
      </v-tab>
      <v-tab ripple>
        Add Trigger
      </v-tab>
      <v-spacer></v-spacer>


      <v-tab-item>
        <v-layout row wrap class="pt-4" align-center justify-center>
          <v-flex xs8>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title class="pl-3">Total Stats</v-toolbar-title>
              </v-toolbar>
              <v-card-text>

                <v-input v-model="test2" />

                <table>
                  <tr>
                    <td>Surveys Completed:</td>
                    <td>{{scoreData.completed}}</td> 
                  </tr>
                  <tr>
                    <td>Average Overall Score:</td>
                    <td>{{scoreData.avgOverall}}</td> 
                  </tr>
                  <tr>
                    <td class="pr-4">Average Hydration Score:</td>
                    <td >{{scoreData.avgHydration}}</td> 
                  </tr>
                  <tr>
                    <td>Average Pores Score:</td>
                    <td>{{scoreData.avgPores}}</td> 
                  </tr>
                  <tr>
                    <td>Average Tone Score:</td>
                    <td>{{scoreData.avgTone}}</td> 
                  </tr>
                </table>
                
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pt-4" align-center justify-center>
          <v-flex xs8>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title class="pl-3">Emails</v-toolbar-title>
              </v-toolbar>
              <v-card-text>

                <input v-model="test2">

                <table>
                  <tr v-for="e in emails">
                    <td>{{e.email}}</td>
                    <td>{{e.subscribe}}</td> 
                  </tr>
                </table>
                
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pt-4" align-center justify-center>
          <v-flex xs8>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title class="pl-3">Question Stats</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md >
                  <v-layout row wrap>
                    <v-flex xs2>
                      SECTION
                    </v-flex>
                    <v-flex xs4>
                      QUESTION TEXT
                    </v-flex>
                    <v-flex xs6>
                      <table style="width:100%">
                        <tr>
                          <td style="width:20%;">COUNT</td>
                          <td>OPTION TEXT</td> 
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                  <v-layout v-for="q in questions" row wrap>
                    <v-flex xs2>
                      {{q.section}}
                    </v-flex>
                    <v-flex xs4>
                      {{q.text}}
                    </v-flex>
                    <v-flex xs6>
                      <table style="width:100%">
                        <tr v-for="o in q.options">
                          <td style="width:20%;">{{o.timesAnswered}}</td>
                          <td>{{o.text}}</td> 
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-container>
                 
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>


      </v-tab-item>
      
      <v-tab-item>
        <v-layout row wrap class="pt-4" align-center justify-center>
          <v-flex xs12 sm10 md6>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title class="pl-3">Add Question</v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <v-form ref="form">
                  <v-text-field v-model="questionId" label="QuestionId:"></v-text-field>
                  <v-text-field v-model="section" label="Section:"></v-text-field>
                  <v-text-field v-model="subSection" label="Subsection:"></v-text-field>
                  <v-text-field v-model="order" label="Order:"></v-text-field>
                  <v-text-field v-model="question" label="Question Text:"></v-text-field>
                  <v-select
                    v-model="questionType"
                    @change="addOption"
                    :items="types"
                    label="Question Type"
                    required
                    ></v-select>

                  <v-card v-show="options.length > 0" class="mb-2" color="teal lighten-5">
                    <v-container grid-list-md text-xs-center>
                      <v-layout row wrap v-for="(o) in options" :key="o.asdf">
                        <v-flex xs3>
                          <v-text-field v-model="o.text" label="Option Text:" required></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field v-model="o.trigger1" label="Trigger 1:"></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field v-model="o.trigger2" label="Trigger 2:"></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field v-model="o.points" label="Points:"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>

                  <v-btn color="teal" dark @click="addOption">Add Option</v-btn>
                  <v-btn color="red" dark @click="removeOption">Remove Option</v-btn>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="teal" dark @click="submit">Add Question</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>

      </v-tab-item>

      <v-tab-item>
        <v-layout row wrap class="pt-4" align-center justify-center>
          <v-flex xs12 sm10 md6>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title class="pl-3">Add Trigger</v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <v-form ref="form">
                  <v-text-field v-model="tag" label="Tag:"></v-text-field>
                  <v-text-field v-model="title" label="Title:"></v-text-field>
                  <v-text-field v-model="frequency" label="Frequency:"></v-text-field>
                  <v-text-field v-model="description" label="Description:"></v-text-field>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="teal" dark @click="addTrigger">Add Trigger</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>

  </section> -->
  <section style="background: white;">
    <section v-if="!authenticated">
      
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex xs12>
            <input style="border: 1px solid; width: 400px;" placeholder="Email" v-model="email" type="email" />
            <br>
            <br>
            <input style="border: 1px solid; width: 400px;"  placeholder="Password"  v-model="password" type="password"/>
            <br>
            <v-btn @click="signIn" color="primary">Login</v-btn>
            
          </v-flex>
        </v-layout>
      </v-container>

    </section>

    <section v-if="authenticated">

      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card class="pa-2">
              <v-card-title style="font-weight: bold; font-size: 18px;">
                Export Data
              </v-card-title>
              <v-card-text class="px-0">
                <v-menu
                  ref="startMenu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDate"
                      label="Start date"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="startDate"
                    :max="endDate"
                    min="1950-01-01"
                    @change="startSave"
                    ></v-date-picker>
                </v-menu>
              
                <v-menu
                  ref="endMenu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDate"
                      label="End date"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="endDate"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="startDate"
                    @change="endSave"
                    ></v-date-picker>
                </v-menu>
                <v-btn v-show="!downloadComplete" @click="download" color="primary">Get Data</v-btn>
                <download-excel
                  v-show="downloadComplete"
                  :data = "test">
                  <v-btn @click="download" color="success">Download</v-btn>
                </download-excel>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
  
    
    </section>
  </section>
</template>

<script>
import db from '@/db';
import firebase from 'firebase';
export default {
  name: 'admin',
  components: {},
  data() {
    return {
      email: '',
      password: '',
      authenticated: false,
      downloadComplete: false,
      startDate: null,
      startMenu: false,
      endDate:  null,
      endMenu: false,
      test: [],
      emails: [],
      scores:[],
      active: null,
      questions: [{
        options: [],
      }],
      questionOptions: [],
      types: ['text', 'number', 'multiSelect', 'singleSelect', 'intro'],
      questionId: 1,
      section: '',
      subSection: '',
      order: 1,
      question: '',
      questionType: '',
      options: [],
      tag: 'T1',
      title: '',
      description: '',
      frequency: ''
    };
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },
  created() {
    // var questionsProcessed = 0;
    // db.collection('question')
    //   .orderBy('section')
    //   .orderBy('order')
    //   .get()
    //   .then(querySnapshot => {
    //     querySnapshot.forEach(doc => {
    //       if (doc.data().type != 'intro' && doc.data().type != 'number' && doc.data().type != 'text'){
    //         this.questions.push(doc.data());
    //       }
    //       questionsProcessed++;
    //       if (questionsProcessed === querySnapshot.docs.length) {
    //         var optionsProcessed = 0;
    //         db.collection('questionOptions')
    //           .orderBy('order')
    //           .get()
    //           .then(querySnapshot => {
    //             querySnapshot.forEach(doc => {
    //               let id = doc.id;
    //               let ok = doc.data();
    //               ok.id = id;
    //               this.questionOptions.push(ok);
    //               optionsProcessed++;
    //               if (optionsProcessed === querySnapshot.docs.length) {
    //                 this.questions.forEach(question => {
    //                   question.options = [];
    //                   var optionsCombined = 0;
    //                   this.questionOptions.forEach(option => {
    //                     optionsCombined++;
    //                     if (question.questionId == option.questionId) {
    //                       question.options.push(option);
    //                     }
    //                   });
    //                 });
    //               }
    //             });
    //           });
    //       }
    //     });
    //   });
    // db.collection('scores')
    //   .get()
    //   .then(querySnapshot => {
    //     querySnapshot.forEach(doc => {
    //       this.scores.push(doc.data());
    //     });
    //   });
    // db.collection('subscribe')
    //   .get()
    //   .then(querySnapshot => {
    //     querySnapshot.forEach(doc => {
    //       this.emails.push(doc.data());
    //     });
    //   });

  },
  computed: {
    // test2: function(){
    //   return JSON.stringify(this.test);
    // },
    // option: function(index) {
    //   return 'Option ' + (index + 1) + ':';
    // },
    // scoreData: function () {
    //   let ok = {
    //     completed: this.scores.length,
    //     totalOverall: 0,
    //     totalHydration: 0,
    //     totalPores: 0,
    //     totalTone: 0,
    //     avgOverall: 0,
    //     avgHydration: 0,
    //     avgPores: 0,
    //     avgTone: 0
    //   };
    //   this.scores.map(s =>{
    //     ok.totalOverall += s.overallScore;
    //     ok.totalHydration += s.hydrationScore;
    //     ok.totalPores += s.poresScore;
    //     ok.totalTone += s.toneScore;
    //   });

    //   ok.avgOverall = ok.totalOverall / ok.completed;
    //   ok.avgHydration = ok.totalHydration / ok.completed;
    //   ok.avgPores = ok.totalPores / ok.completed;
    //   ok.avgTone = ok.totalTone / ok.completed;

    //   ok.avgOverall = Math.round(ok.avgOverall * 100) / 100;
    //   ok.avgHydration = Math.round(ok.avgHydration * 100) / 100;
    //   ok.avgPores = Math.round(ok.avgPores * 100) / 100;
    //   ok.avgTone = Math.round(ok.avgTone * 100) / 100;

    //   return ok;
    // }
  },
  methods: { 
    download(){
      console.log(this.startDate);
      console.log(this.endDate);
      var start = new Date(this.startDate);
      var end = new Date(this.endDate);
      start.setDate(start.getDate()+1);
      start.setHours(0,0,0,0);
      end.setDate(end.getDate()+1);
      end.setHours(23,59,59,999);
      console.log(start);
      console.log(end);

      var assessmentsRef = db.collection('assessments');


      var processed = 0;
      var query2 = assessmentsRef
        .orderBy('date')
        .startAt(start)
        .endAt(end)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            var ok = doc.data();

            var flat = this.flatten(doc.data());
            flat.date = ok.date.toDate();
            delete flat.date_compareTo;
            delete flat.dateisEqual;
            delete flat.datenanoseconds;
            delete flat.dateseconds;
            delete flat.datetoDate;
            delete flat.datetoMillis;
            delete flat.datetoString;

            this.test.push(flat);
            processed++;
            if (processed === querySnapshot.docs.length) {
              this.downloadComplete = true;
            }
          });

        });




    },
    flatten(data){
      var result = {};
      function recurse (cur, prop) {
        if (Object(cur) !== cur) {
          result[prop] = cur;
        } else if (Array.isArray(cur)) {
          for(var i=0, l=cur.length; i<l; i++)
            recurse(cur[i], prop + '[' + i + ']');
          if (l == 0)
            result[prop] = [];
        } else {
          var isEmpty = true;
          for (var p in cur) {
            isEmpty = false;
            recurse(cur[p], prop ? prop+''+p : p);
          }
          if (isEmpty && prop)
            result[prop] = {};
        }
      }
      recurse(data, '');
      return result;
    },
    startSave (date) {
      this.downloadComplete = false;
      this.$refs.startMenu.save(date);
    },
    endSave (date) {
      this.downloadComplete = false;
      this.$refs.endMenu.save(date);
    },
    removeOption: function() {
      this.options.pop();
    },
    addOption: function() {
      this.options.push({
        questionId: this.questionId,
        text: '',
        trigger1: '',
        trigger2: '',
        trigger3: '',
        points: 0,
        timesAnswered: 0
      });
    },
    submit: function() {
      this.questionId = parseInt(this.questionId);
      this.order = parseInt(this.order);

      db.collection('question')
        .doc(this.newGuid())
        .set({
          order: this.order,
          questionId: this.questionId,
          section: this.section,
          subSection: this.subSection,
          text: this.question,
          timesAnswered: 0,
          type: this.questionType
        })
        .then(() => {
          console.log('Question successfully written!');
          let order = 0;

          this.options.forEach(option => {
            order += 1;
            db.collection('questionOptions')
              .doc(this.newGuid())
              .set({
                questionId: this.questionId,
                text: option.text,
                trigger1: option.trigger1,
                trigger2: option.trigger2,
                points: option.points,
                order: order,
                timesAnswered: 0
              })
              .then(() => {
                console.log('Option successfully written!');
              })
              .catch(function(error) {
                alert('error');
                console.error('Error writing option: ', error);
              });
          });
          this.clearForm();
        })
        .catch(function(error) {
          alert('error');
          console.error('Error writing question: ', error);
        });
    },
    addTrigger: function() {
      db.collection('trigger')
        .doc(this.newGuid())
        .set({
          tag: this.tag,
          title: this.title,
          frequency: this.frequency,
          description: this.description
        })
        .then(() => {
          console.log('Trigger successfully written!');
          let nextNumber = 0;

          nextNumber = parseInt(this.tag.substring(1, this.tag.length));
          this.tag = 'T' + (nextNumber + 1);
          this.title = '';
          this.description = '';
        })
        .catch(function(error) {
          alert('error');
          console.error('Error writing trigger: ', error);
        });
    },
    clearForm: function() {
      this.order = parseInt(this.order) + 1;
      this.questionId = parseInt(this.questionId) + 1;
      this.question = '';
      this.options = [];
    },
    newGuid: function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    signIn(){
      firebase.auth().signInWithEmailAndPassword(this.email,this.password)
        .then((user)=>{
          this.authenticated = true;
        })
        .catch((e)=>{
          this.authenticated = false;
          alert(e.message);
        });
    }
  }
};
</script>

<style scoped>
</style>
